import styled from "styled-components";
import { Tooltip as ReactTooltip } from "react-tooltip";

const Tooltip = styled(ReactTooltip)`
  padding: 3px 14px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 500;
  background: #4a4a4a !important;

  &.transform-none {
    text-transform: none;
  }

  &:after {
    display: none;
  }

  &.question-card {
    padding: 0px;
    border-radius: 8px;
    transform: scale(0.9);
    transform-origin: right;
    max-width: 60vw;
    max-height: 40vw;
    contain: content;
    z-index: 100000;
  }
`;

export default Tooltip;
